exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".rating-category[data-v-0e78a3da]{cursor:pointer;padding:0 4px;border:thin solid #7d7d7d;border-radius:2px;display:inline-block;margin:2px;font-size:12px}.rating-category[data-v-0e78a3da]:hover{border-color:#484848}", ""]);

// exports
